module.exports = urlUtils = {
  parseLocationHash: () ->
    this.parseQueryString(location.hash.replace(/^#/,''))

  currentFragment: () ->
    frag = location.hash.replace(/^#/,'')
    if frag.length
      frag = '#' + frag
    return frag

  parseQueryString: (qs) ->
    params = {}
    qs = qs.replace(/^\?/,'')
    Array.from(qs.split('&')).forEach (q)->
      i = q.split('=')
      if i[0] and i[1]
        i[0] = i[0].replace(/\[\]$/, '') # when key is using array like syntax, we will just concat with , like expected format
        i[1] = unescape(i[1])
        if( params[i[0]] )
          params[i[0]] += ','+i[1]
        else
          params[i[0]] = i[1]
    return params

  buildQueryString: (queryMap, skipKeyEncode) ->
    urlQuery = []
    urlPath = ''
    for key of queryMap
      urlQuery.push( (if skipKeyEncode then key else encodeURIComponent(key)) + "=" + encodeURIComponent(queryMap[key]))
    if urlQuery.length
      urlPath = '?' + urlQuery.join('&')
    return urlPath

  setFragment: (frag) -> # by default we are passive, replacing state instead of adding new entries, this is because we do not respond to back button when the hash alone changes
    if history.replaceState and history.state
      qs = window.location.search.replace(/^\?/,'')
      qs = '?' + qs if qs.length
      frag = '#' + frag if frag.length
      history.replaceState(history.state,document.title,window.location.pathname + qs + frag)
    else
      location.hash = frag

  getSelectedSort: (opts) ->
    possible = document.querySelectorAll('#result-sorts input')
    result = Array.from(possible).find (input)->
      return !input.matches('.default') && input.checked
    result = result.getAttribute('data-sort') if result
    return result or opts?.sort

  getSelectedRating: (opts) ->
    possible = document.querySelectorAll('#result-ratings input')
    result = Array.from(possible).find (input)->
      return !input.matches('.default') && input.checked
    result = result.getAttribute('data-rating') if result
    return result or opts?.rating

  apiQueryBuilder: (opts) ->
    sort = this.getSelectedSort(opts)
    query_filter_string = ""
    if opts.filterQuery
      query_filter_string = "filterQuery=#{opts.filterQuery}"
    else if opts.isCategoryFallback
      query_filter_string = "categoryFallback=#{opts.categoryFallback}"
    else
      query_filter_string = "dealType=#{opts.dealType}"
    query_filter_string += "&context=#{opts.context}" if opts.context
    query_filter_string += "&divisionOverride=#{opts.division}" if opts.division
    query_filter_string += "&showUrgentPerc=#{opts.showUrgentPerc}" if opts.showUrgentPerc
    query_filter_string += "&showOptions=#{opts.showOptions}" if opts.showOptions
    query_filter_string += "&showBestOption=true" if opts.showBestOption
    query_filter_string += "&divisionLoc=#{opts.latLng}" if opts.latLng and opts.filterQuery
    query_filter_string += "&divisionLocale=#{opts.divisionLocale}" if opts.divisionLocale and opts.filterQuery
    query_filter_string += "&divisionTz=#{opts.divisionTz}" if opts.divisionTz
    query_filter_string += "&pageType=#{opts.pageType}" if opts.pageType
    query_filter_string += "&apiFacets=#{escape(opts.apiFacets)}" if opts.apiFacets
    query_filter_string += "&unsafe=#{opts.unsafe}" if opts.unsafe
    query_filter_string += "&omitHero=true" if opts.noHero
    query_filter_string += "&extraShow=#{opts.extraShow}" if opts.extraShow
    query_filter_string += "&extraRapiShow=#{opts.extraRapiShow}" if opts.extraRapiShow && opts.extraRapiShow != opts.extraShow
    query_filter_string += "&renderOptions=#{opts.renderOptions}" if opts.renderOptions
    query_filter_string += "&sort=#{sort}" if sort
    query_filter_string += "&includeHtml=true" if opts.includeHtml

    if opts.includeQuery and window.location.search
      query_filter_string += window.location.search.replace(/^\?/,'&')
    query_filter_string
}
